// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1tS_L","cell":"ColumnAccessor_cell__3IECk","firstCellAccent":"ColumnAccessor_firstCellAccent__1Nftq"};